import type { MachineSetupRepository } from '../data/machine-setup-repository';
import type { SerialValidationResponse } from '../types/machine-setup-types';

export class ValidateSerialUseCase {
  constructor(private readonly repository: MachineSetupRepository) {}

  async execute(serialNumber: string): Promise<SerialValidationResponse> {
    if (!serialNumber || serialNumber.trim() === '')
      throw new Error('Serial number is required');

    const response = await this.repository.validateSerial(serialNumber.trim());
    if (!response.isSuccess) throw new Error(response.message || 'Failed to validate serial number');
    return response;
  }
}
